import React, { useState } from "react"
import { Link } from "react-router-dom"
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap"
import SimpleBar from "simplebar-react"
import notificationIcon from "../../../assets/images/icons/notification.svg"
import moment from "moment"
import { useReadNotificationMutation } from "store/api/user/user.api"
import NoData from "../../../assets/images/noData.svg"
import { usePermission } from "hooks/usePermission"
import useNotification from "hooks/useNotification"
import { useSelector } from "react-redux"

//i18n

const NotificationDropdown = () => {
  const { notifications: data, count, reloadNotifications } = useNotification()
  const [menu, setMenu] = useState(false)
  const [mutate] = useReadNotificationMutation()
  const { hasAnyPermission } = usePermission()
  const { userType } = useSelector((state) => state.user)

  const showTime = (createdAt) => {
    return moment(createdAt).fromNow()
  }

  const onHandleReadNotification = async (item) => {
    setMenu(false)
    if (!item.read) {
      try {
        const { success } = await mutate(item.id).unwrap()
        if (success) {
          reloadNotifications()
        }
      } catch (err) {}
    }
  }

  const canAccess = (per) => {
    if (userType === "WEALTH_PARTNER") {
      return true
    }
    if (!hasAnyPermission(per)) {
      return false
    }

    return true
  }

  const getTitleWithReadLabel = (item) => {
    return (
      <>
        {!item.read && (
          <p
            style={{
              marginBottom: "5px",
            }}
          >
            <span
              style={{
                padding: "2px 5px",
                borderRadius: "10px",
                color: "#fff",
                background: "#09518c",
                fontSize: "0.8em",
                marginRight: "2px",
              }}
            >
              Unread
            </span>
          </p>
        )}
        <div dangerouslySetInnerHTML={{ __html: item.title }} />
      </>
    )
  }

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon position-relative"
          tag="button"
          id="page-header-notifications-dropdown"
        >
          {/* <i className="bx bx-bell bx-tada" /> */}
          <img src={notificationIcon} alt="menuBurger" height={"25px"} />
          {count > 0 && (
            <span className="badge bg-danger rounded-pill">{count}</span>
          )}
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0"> Notifications </h6>
              </Col>
              {/* <div className="col-auto">
                <a href="#" className="small">
                  {" "}
                  View All
                </a>
              </div> */}
            </Row>
          </div>
          {data.length > 0 && (
            <SimpleBar style={{ height: "230px" }}>
              {data.map((item, index) => (
                <React.Fragment key={`notification_${index}`}>
                  {canAccess(item.permission) && (
                    <Link
                      to={item.url}
                      className="text-reset notification-item"
                      onClick={() => onHandleReadNotification(item)}
                    >
                      <div className="d-flex">
                        {/* <div
                          className="avatar-xs me-3"
                          style={{ minWidth: "32px" }}
                        >
                          <span className="avatar-title bg-primary rounded-circle font-size-16">
                            <i className="bx bx-cart" />
                          </span>
                        </div> */}
                        <div className="flex-grow-1">
                          <h6 className="mt-0 mb-1">
                            {getTitleWithReadLabel(item)}
                          </h6>

                          <div className="font-size-12 text-muted">
                            {item?.description && (
                              <p className="mb-1">{item.description} </p>
                            )}
                            <p className="mb-0">
                              <i className="mdi mdi-clock-outline" />{" "}
                              {showTime(item.createdAt)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </Link>
                  )}
                </React.Fragment>
              ))}
            </SimpleBar>
          )}

          {data.length <= 0 && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "250px",
              }}
            >
              <img
                src={NoData}
                style={{
                  maxWidth: "160px",
                }}
                alt="Record not found"
              />
              <h4
                style={{
                  color: "#000000",
                  fontSize: "16px",
                  fontWeight: "600",
                  marginTop: "15px",
                  marginBottom: "5px",
                  textAlign: "center",
                }}
              >
                {"No Records Found"}
              </h4>
            </div>
          )}
          {data.length > 0 && (
            <div className="p-2 border-top d-grid">
              <Link
                className="font-size-14 text-center"
                to="/notifications"
                onClick={() => setMenu(false)}
              >
                <i className="mdi mdi-arrow-right-circle me-1"></i>{" "}
                <span key="t-view-more">View All</span>
              </Link>
            </div>
          )}
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

export default NotificationDropdown
